// extracted by mini-css-extract-plugin
module.exports = {"static":"z_Q","map":"z_R"};